import { unsafeCoerce } from 'fp-ts/lib/function';
import { Dispatch, useEffect, useState } from 'react';
import { useBrowser } from '../services/BrowserService';

const parseStorageValue = <T>(key: string, defaultValue: T, window: Window | undefined) => {
  let saved = null;

  try {
    saved = window?.localStorage.getItem(key);
  } catch (e) {
    // Local storage is not available
    return defaultValue;
  }

  const initial: T = unsafeCoerce(JSON.parse(saved ?? 'null'));

  return initial ?? defaultValue;
};

export const useLocalStorage = <T>(key: string, defaultValue: T): [T, Dispatch<T>] => {
  const { window } = useBrowser();

  const [value, setValue] = useState(() => parseStorageValue(key, defaultValue, window));

  let localStorage: Storage | undefined = undefined;

  try {
    localStorage = window?.localStorage;
  } catch (e) {
    // Local storage is not available
  }

  useEffect(() => {
    try {
      localStorage?.setItem(key, JSON.stringify(value));
    } catch (e) {
      // Local storage is not available
    }
  }, [key, value, localStorage]);

  return [value, setValue];
};
